import React, { FC, ReactNode } from 'react'

import { twMerge } from '../../tailwind/merge'
import { Box } from '../box'
import { Text } from '../text'

export type TimeDividerProps = {
    /** Time label shown between the two rules, e.g. `14:42`. */
    time: ReactNode
    /** Flight list shown in UTC: the label reads "14:42 UTC". */
    utc?: boolean
    className?: string
    testID?: string
}

/**
 * Horizontal time separator for the flight/towing lists (Figma TimeDivider
 * 190:23631): a short 24px leading rule, the time in a 1px `graphics/grey`
 * pill (P3 medium, `content/default`), then a hairline rule that fills the
 * remaining width. In UTC mode the label gets a "UTC" suffix.
 */
export const TimeDivider: FC<TimeDividerProps> = ({ time, utc, className, testID }) => (
    <Box className={twMerge('h-5 flex-row items-center gap-2', className)} testID={testID}>
        <Box className='h-px w-6 bg-graphics-grey' />
        <Box className='flex-row items-center rounded-common border border-solid border-graphics-grey px-2'>
            <Text size='P3' weight='medium' className='whitespace-nowrap'>
                {time}
                {utc && ' UTC'}
            </Text>
        </Box>
        <Box className='h-px flex-1 bg-graphics-grey' />
    </Box>
)

TimeDivider.displayName = 'TimeDivider'
